<template>
  <div>
    <a-table
      :scroll="{ x: 1500, y: null }"
      :columns="columns"
      :row-key="(record) => record.uuid"
      :data-source="entreprises"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
    >
      <template #name="{ record }">
        <div style="color: black; font-weight: #2b3e50">{{ record.name }}</div>
        <div style="color: #647c92">{{ record.internal_number }}</div>
      </template>

      <template #graphique="{ record }">
        <div
          v-if="record.is_graph"
          @click="$router.push('/graphique/pop/_c_/' + record.internal_number)"
        >
          <img
            style="cursor: pointer"
            alt="Graph"
            src="../assets/icons/diagramme.png"
            width="32"
          />
        </div>
      </template>

      <template #iC="{ record }">
        <a-button type="link" @click="showAllByNumEntreprise(record, 'ec')">
          {{ record.iC }}
        </a-button>
      </template>

      <template #assure_benef="{ record }">
        <a-button type="link" @click="showAllByNumEntreprise(record, 'ea')">
          {{ record.iA }} / {{ record.iB }}
        </a-button>
      </template>

      <template #coti="{ record }">
        <div
          style="cursor: pointer"
          @click="showAllByNumEntreprise(record, 'etc')"
        >
          <div style="color: green">
            <span v-money-format="record.iCo[0]"></span> €
          </div>
          <div style="color: olive">
            <span v-money-format="record.iCo[1]"></span> €
          </div>
        </div>
      </template>

      <template #presta="{ record }">
        <div
          style="cursor: pointer"
          @click="showAllByNumEntreprise(record, 'ep')"
        >
          <div style="color: green">
            <span v-money-format="record.iPr[0]"></span> €
          </div>
          <div style="color: olive">
            <span v-money-format="record.iPr[1]"></span> €
          </div>
        </div>
      </template>

      <template #iT="{ record }">
        <Progress
          :percent="record.iT"
          :label="record.iT"
          :key="record.iT + record.uuid"
        />
      </template>

      <template #documents="{ record }">
        <img
          v-if="record.has_documents"
          @click="$router.push('/docs/e/' + record.internal_number)"
          style="cursor: pointer"
          alt="Graph"
          src="../assets/icons/folder.svg"
          width="26"
        />
      </template>
    </a-table>
  </div>
</template>

<script>
import Progress from "./ui/progress.vue";

const columns = [
  {
    title: "Entreprises",
    width: 220,
    sorter: true,
    dataIndex: "name",
    key: "name",
    defaultSortOrder: "ascend",
    slots: {
      customRender: "name",
    },
  },
  {
    title: "Stat.",
    key: "graphique",
    dataIndex: "graphique",
    width: 40,
    align: "center",
    slots: {
      customRender: "graphique",
    },
  },
  {
    title: "Contrats",
    width: 72,
    dataIndex: "iC",
    key: "iC",
    align: "center",
    slots: {
      customRender: "iC",
    },
  },
  {
    title: "Assurés/ayants droit",
    width: 120,
    dataIndex: "iA",
    key: "iA",
    align: "center",
    slots: {
      customRender: "assure_benef",
    },
  },
  {
    title: "Cotisations encaissées",
    width: 100,
    dataIndex: "iCo",
    key: "iCo",
    align: "right",
    slots: {
      customRender: "coti",
    },
  },
  {
    title: "Prestations survenues",
    width: 100,
    dataIndex: "iPr",
    key: "iPr",
    align: "right",
    slots: {
      customRender: "presta",
    },
  },
  {
    title: "Télétransmision",
    dataIndex: "iT",
    key: "iT",
    fixed: "right",
    width: 88,
    sorter: true,
    slots: {
      customRender: "iT",
    },
  },
  {
    title: "Documents",
    dataIndex: "documents",
    key: "documents",
    fixed: "right",
    width: 60,
    slots: {
      customRender: "documents",
    },
  },
];

export default {
  name: "EntrepriseTable",
  components: {
    Progress,
  },
  props: {
    params: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      columns,

      sort: {
        columnKey: null,
        order: null,
      },

      entreprisesData: {},

      loading: false,

      timeout: 0,
    };
  },
  watch: {
    spaEr(_) {
      // Reset Pagination
      this.params.page = 1;
      this.getEntreprises();
    },
    _searchValue(_) {
      clearTimeout(this.timeout);

      this.timeout = setTimeout(() => {
        this.params.page = 1;
        this.getEntreprises();
      }, 500);
    },
  },
  methods: {
    getEntreprises() {
      this.loading = true;

      this.axios
        .get(
          `data/companys/${this.numHolding}/${
            this.spaEr
          }/?${new URLSearchParams(this.params)}`
        )
        .then((r) => {
          if (r.status === 200) {
            this.entreprisesData = r.data;

            setTimeout(() => {
              this.loading = false;
            }, 100);
          }
        });
    },
    handleTableChange(pag, _, sorter) {
      this.loading = true;
      this.sort.columnKey = sorter.columnKey;
      this.sort.order = sorter.order;

      this.params.page = pag.current;

      this.getEntreprises();
    },
    showAllByNumEntreprise(entreprise, subPage) {
      this.$emit("show-abne", entreprise, subPage);
    },

    docs(from, num) {
      this.$router.push({
        name: "docs",
        params: {
          from: from,
          num: num,
        },
      });
    },
  },
  computed: {
    _searchValue() {
      return this.params.searchValue;
    },
    spaEr() {
      return this.params.spaEr.spa + this.params.spaEr.er.status;
    },
    numHolding() {
      return this.$route.params.numHolding;
    },
    headers() {
      return this.$store.getters.headers.hhp;
    },
    ac() {
      return this.$store.getters.activeColumns.h;
    },
    noZeroData() {
      return this.$store.getters.noZeroData.h;
    },
    pagination() {
      return {
        total: this.entreprisesData.total,
        current: this.entreprisesData.current_page,
        columnKey: this.params.columnKey,
        order: this.params.order,
      };
    },
    entreprises() {
      return this.entreprisesData.data;
    },
  },
  mounted() {
    this.getEntreprises();
  },
};
</script>

<style>
.ant-table-tbody > tr > td {
  padding: 4px 16px !important;
}

.ant-table-tbody > tr > td {
  border-bottom: 4px solid #f1f1f1 !important;
  white-space: nowrap;
}

.ant-table td {
  white-space: nowrap;
}
.ui.basic.blue.button.plus {
  margin: auto;
  margin: 10px 0 0 48%;
}
</style>
